import { RefetchFunction } from "@apollo/client/react/hooks/useSuspenseQuery";
import { Box, Stack, Typography } from "@mui/material";
import QuestionItem from "pages/Skill/view/components/QuestionItem/components/QuestionItem";
import { QuestionItemType } from "pages/Skill/view/types";
import qs from "qs";
import { useEffect, useMemo, useRef } from "react";
import { useSearchParams } from "react-router-dom";

interface QuestionProps {
  question: QuestionItemType;
  competencyTitle: string;
  knowledgeBlockTitle: string;
  skillTitle: string;
  refetch: RefetchFunction<any, any>;
  competencyMapId: string;
}

const Question = ({
  question,
  competencyTitle,
  knowledgeBlockTitle,
  skillTitle,
  refetch,
  competencyMapId,
}: QuestionProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const { scrollIntoViewId, ...params } = useMemo(() => qs.parse(searchParams.toString()), [searchParams]) as {
    scrollIntoViewId?: string;
  };

  useEffect(() => {
    if (ref && scrollIntoViewId && scrollIntoViewId === question.id) {
      ref.current?.scrollIntoView({ behavior: "smooth" });
      setSearchParams(qs.stringify(params), { replace: true });
    }
  }, [scrollIntoViewId, ref]);

  return (
    <Stack
      key={question.id}
      ref={ref}
      sx={{ backgroundColor: "white", borderRadius: 2, px: 2, paddingTop: 2 }}>
      <Stack
        direction='row'
        flexWrap='wrap'
        sx={{ columnGap: 2 }}>
        <Typography variant='subtitle18rg'>
          <b>Компетенция:</b> {competencyTitle}
        </Typography>
        <Typography variant='subtitle18rg'>
          <b>Блок знаний:</b> {knowledgeBlockTitle}
        </Typography>
        <Typography variant='subtitle18rg'>
          <b>Навык:</b> {skillTitle}
        </Typography>
      </Stack>
      <Box sx={{ backgroundColor: "white", borderRadius: 2 }}>
        <QuestionItem
          question={question}
          refetch={refetch}
          navigateToQuestionSearch={qs.stringify({ mapId: competencyMapId })}
          showConfirmationInfo
        />
      </Box>
    </Stack>
  );
};

export default Question;
